import { useContext } from "react";
import { DataContext } from "../../context/Data.context";
import { Link } from "react-router-dom";

const PageHeader = () => {
  const { data } = useContext(DataContext);

  return <>
    <nav className="navbar fixed-top bg-primary">
      <div className="container-fluid">

        <div className="row align-items-center pt-2 pb-2" style={{ width: "100%" }}>
          <div className="col-1 p-0">
            {!data.pageHeader.backButton || !data.pageHeader.previousPage && <>
              &nbsp;
            </>}

            {data.pageHeader.backButton && data.pageHeader.previousPage && <>
              <Link to={data.pageHeader.previousPage} className="p-3">
                <i className="fas fa-chevron-left text-white"></i>
              </Link>
            </>}
          </div>
          <div className="col text-center text-white text-uppercase">
            <strong>{data.pageHeader.title || ""}</strong>
          </div>
          <div className="col-1 p-0 text-end">

            {!data.pageHeader.actionButton || !data.pageHeader.nextPage && <>
              &nbsp;
            </>}

            {typeof data.pageHeader.nextPage === "string" && <>
              {data.pageHeader.actionButton && data.pageHeader.nextPage && <>
                <Link to={data.pageHeader.nextPage} className="p-3">
                  <i className="fas fa-plus text-white"></i>
                </Link>
              </>}
            </>}

            {typeof data.pageHeader.nextPage === "function" && <>
              {data.pageHeader.nextPage()}
            </>}

          </div>
        </div>

      </div>
    </nav>
  </>
};

export default PageHeader;